module.exports = __webpack_public_path__ + "lr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/lr.svg
// module id = 664
// module chunks = 0